import classNames from "classnames";
import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { useIdCopy } from "@hooks/useIdCopy";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { HStack } from "@design-system/HStack/HStack";
import { ClassAvatar } from "@components/avatar/ClassAvatar";
import { ClassRow } from "../viewUtils";
import styles from "../ClassesSettings.module.scss";

export const NameCell = memo(function NameCell({
    row,
}: CellContext<ViewTableFeatures, ClassRow, unknown>) {
    const item = row.original;
    const { getCopyProps } = useIdCopy({ label: "Class" });
    const subclassCount = item.children?.length ?? 0;

    return (
        <ViewTableCell>
            <HStack
                align="center"
                className={classNames(
                    styles.classIdCell,
                    item.parentId && styles.classIdCellSubClass,
                )}
            >
                {!item.parentId && (
                    <ClassAvatar
                        class={item.classInstance}
                        size="sm"
                        aria-hidden
                    />
                )}
                <span
                    className={classNames(styles.classItemLabel, {
                        [styles.classItemLabelCollapsible]: !item.parentId,
                    })}
                    {...getCopyProps(item.id)}
                >
                    {item.label}
                </span>
                {subclassCount > 0 && (
                    <span className={styles.subclassCount}>
                        {subclassCount}
                    </span>
                )}
            </HStack>
        </ViewTableCell>
    );
});
